import React from "react";

const CARDS = [
  {
    quote: "I want to give each student feedback. I just don't have the time.",
    title: "Despite Their Best Interest",
    body:
      "Teachers, despite genuine intent, do not have the time to fully cater to every student's reflective needs.",
  },
  {
    title: "Teachers Are Stretched Thin",
    body:
      "One teacher may oversee numerous students, making focused, meaningful reflection feedback impractical at scale.",
  },
  {
    title: "Reflection Is Critical For Deep Learning",
    body:
      "Students learn from good reflection; good reflection needs quality guidance — but it is rarely supported under institutional constraints.",
  },
];

const ProfEMentorGap: React.FC = () => (
  <section className="pe-section pe-section--cyan pe-mentor">
    <div className="pe-container pe-mentor__layout">
      <div className="pe-mentor__portrait">
        <div className="pe-mentor__portrait-frame">
          <img
            className="pe-mascot-img"
            src="/images/prof-e/pose-3-warm.png"
            alt="Professor E"
          />
        </div>
        <div className="pe-mentor__caption">
          &ldquo;We do not learn from experience…
          <br />
          we learn from reflecting on experience.&rdquo;
          <span className="pe-mentor__caption-name">— John Dewey</span>
        </div>
      </div>

      <div className="pe-mentor__content">
        <h2>Reflection needs a mentor — but teachers can&rsquo;t do it alone.</h2>
        <ul className="pe-mentor__cards">
          {CARDS.map((c) => (
            <li className="pe-mentor__card" key={c.title}>
              {c.quote && (
                <div className="pe-mentor__card-quote">
                  &ldquo;{c.quote}&rdquo;
                </div>
              )}
              <h3 className="pe-mentor__card-title">{c.title}</h3>
              <p className="pe-mentor__card-body">{c.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default ProfEMentorGap;
